/**
 * MRD JS
 */
export const MRD = (function () {


    var listings = {



        getEvents : function (tags) {   
            
            var encoded = Util.encodeParam(tags);
        
            return $.ajax({
                url: `mrd/listings/events?${encoded}`,
                type: 'GET'

            });
        },
        getTags : function () {

            return $.ajax({
                url: `mrd/listings/tags`,
                type: 'GET'
            });
        }

    }

    return {
        listings: listings
    }

}());


